module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/55e835621ad012682f5094922f5deaf4.png";